module.exports = __webpack_public_path__ + "static/media/eclipse-alt.f66b3c94.svg";